import { getTermoNotificacaoPublico } from "@/contexts/fiscalizacao/termoNotificacao/api/termoNotificacaoApi";
import { ImpressaoTermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/components/ImpressaoTermoNotificacao/ImpressaoTermoNotificacao";
import { TermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/model/TermoNotificacao";
import { PrinterOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { useReactToPrint } from "react-to-print";

export function VisualizacaoPrintTermoNotificacao() {
  const { codigoVerificador } = useParams<{ codigoVerificador: string }>();
  const termoNotificacaoRef = useRef<HTMLDivElement>(null);
  const [termo, setTermo] = useState<TermoNotificacao>();

  useEffect(() => {
    document.title = "Inspeção Mobile - Impressão do Termo de Notificação";

    if (codigoVerificador) {
      getTermoNotificacaoPublico(codigoVerificador)
        .then(setTermo)
        .catch((error) => {
          console.error("Erro ao buscar termo de notificação:", error);
        });
    }
  }, [codigoVerificador]);

  const handlePrint = useReactToPrint({
    contentRef: termoNotificacaoRef,
    documentTitle: `Termo de Notificação ${termo?.numero}`,
    suppressErrors: true,
    preserveAfterPrint: true,
  });

  return (
    <>
      <Result
        title={`Impressão do Termo de Notificação ${termo?.numero || ""}`}
        icon={<PrinterOutlined />}
        extra={
          <Button type="primary" onClick={handlePrint} disabled={!termo}>
            Imprimir
          </Button>
        }
      />
      <div style={{ display: "none" }}>
        <ImpressaoTermoNotificacao
          ref={termoNotificacaoRef}
          item={termo || null}
          marcadagua=""
        />
      </div>
    </>
  );
}
